import { PRODUCT_STATUS } from "./message.model";

export interface FileSchema {
  filename: string;
  size: number;
  mimetype: string;
  uploadedAt: Date;
}

export interface thumbnailSchema {
  productCard: FileSchema;
  productPreviewLarge: FileSchema[];
}

export interface descriptionSchema {
  highlight: string;
  whatYouGet: string;
  howToDownload: string;
  delivery: string;
  assetInfo: string;
}

export interface productSchema {
  folderId: string;
  category: string;
  status: PRODUCT_STATUS | PRODUCT_STATUS.CREATED;
  tags: string[];
  price: number;
  description: descriptionSchema;
  thumbnails: thumbnailSchema;
  assets: FileSchema[];
  createdAt: Date;
  updatedAt: Date;
}

export const ProductFormKeys = {
  folderId: "folderId",
  category: "category",
  status: "status",
  price: "price",
  tags: "tags",
  description: {
    highlight: "highlight",
    whatYouGet: "whatYouGet",
    howToDownload: "howToDownload",
    delivery: "delivery",
    assetInfo: "assetInfo",
  },
  thumbnails: {
    productCard: "productCard",
    productPreviewLarge: "productPreviewLarge",
  },
  assets: "assets",
  createdAt: "createdAt",
  updatedAt: "updatedAt",
} as const;
